import { IBarcode } from '@app/models/barcode.interface';
import { IStorage } from '@app/models/storage.interface';
import { createAction, props } from '@ngrx/store';

export const loadStorages = createAction(
  '[Storages] Load Storages',
  props<any>()
);

export const loadStoragesSuccess = createAction(
  '[Storages] Load Storages Success',
  props<{ storages: IStorage[], total: number }>()
);

export const loadStoragesFailure = createAction(
  '[Storages] Load Storages Failure',
  props<{ error: any }>()
);


export const loadStoragesPath = createAction(
  '[Storages] Load Storages Path',
  props<{ storageStructureID: any, locationID:any }>()
);

export const loadStoragesPathSuccess = createAction(
  '[Storages] Load Storages Path Success',
  props<{ storagesPath: IStorage[] }>()
);

export const loadStoragesPathFailure = createAction(
  '[Storages] Load Storages Path Failure',
  props<{ error: any }>()
);






export const filterByCategory = createAction(
  '[Storages] Filter Storages By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Storages] Filter Storages By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Storages] Filter Storages By Category Failure',
  props<{ error: any }>()
);

export const saveStorage = createAction(
  '[Storages] Save Storage',
  props<{ form: any }>()
);

export const saveStorageSuccess = createAction(
  '[Storages] Save Storage Success',
  props<any>()
);

export const saveStorageFailure = createAction(
  '[Storages] Save Storage Failure',
  props<{ error: any }>()
);

export const updateStorage = createAction(
  '[Storages] Update Storage',
  props<{ form: any }>()
);

export const updateStorageSuccess = createAction(
  '[Storages] Update Storage Success',
  props<{ storage: any }>()
);

export const updateStorageFailure = createAction(
  '[Storages] Update Storage Failure',
  props<{ error: any }>()
);

export const loadStorage = createAction(
  '[Storages] Load Storage',
  props<{ storageStructureID: any }>()
);

export const loadStorageSuccess = createAction(
  '[Storages] Load Storage Success',
  props<{ storage: any }>()
);

export const loadStorageFailure = createAction(
  '[Storages] Load Storage Failure',
  props<{ error: any }>()
);

export const filterByArea = createAction(
  '[Storages] Filter Storages By Area',
  props<{ prdAreaID: number, active: string, direction: string }>()
);

export const filterByAreaSuccess = createAction(
  '[Storages] Filter Storages By Area Success',
  props<any>()
);

export const filterByAreaFailure = createAction(
  '[Storages] Filter Storages By Area Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Storages] Search',
  props<{ query: string}>()
);

export const searchSuccess = createAction(
  '[Storages] Search Success',
  props<{ storages: IStorage[], total: number}>()
);

export const searchFailure = createAction(
  '[Storages] Search Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Storages] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Storages] Reset Pagination'
);

export const resetStorages = createAction(
  '[Storages] Reset Storages'
);

export const incrementPageSuccess = createAction(
  '[Storages] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Storages] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Storages] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Storages] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Storages] Set Filter Type',
  props<{ filterType: string, filterID: number }>()
);

export const setSelected = createAction(
  '[Storages] Set Selected',
  props<{ selected: any }>()
);

export const setSort = createAction(
  '[Storages] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetStorage = createAction(
  '[Storages] Reset Storage'
);

export const resetFilter = createAction(
  '[Storages] Reset Filter'
)

export const setDeselected = createAction(
  '[Storages] Set Deselected'
);

export const deleteStorages = createAction(
  '[Storages] Delete Storages',
  props<any>()
);

export const deleteStoragesSuccess = createAction(
  '[Storages] Delete Storages Success',
  props<any>()
);

export const deleteStoragesFailure = createAction(
  '[Storages] Delete Storages Failure',
  props<{ error: any }>()
);

export const deleteStorage = createAction(
  '[Storages] Delete Storage',
  props<{storageStructureID: number }>()
);

export const deleteStorageSuccess = createAction(
  '[Storages] Delete Storage Success',
  props<any>()
);

export const deleteStorageFailure = createAction(
  '[Storages] Delete Storage Failure',
  props<{ error: any, storageStructureID?: number }>()
);

export const createBarcodeFailure = createAction(
  '[Storages] Create Barcode Failure',
  props<{ error: any }>()
);

export const exportStorages = createAction(
  '[Storages] Export Storages'
);


export const setIsLoading = createAction(
  '[Storages] Set Is Loading',
  props<{ isLoading: boolean }>()
);

